import { Breakpoints, Layout } from '@volkswagen-onehub/components-core';
import * as React from 'react';
import { PopupHuchaCardBackground, PopupHuchaCardBackground2 } from './hucha-card-background';

export const PopupHuchaCardContainer: React.FC<{ children: React.ReactNode }> = ({ children }) => {
	return (
		<PopupHuchaCardBackground
			stretchContent
			verticalAlign="center"
			horizontalAlign="center"
			data-testid="hucha-card-container"
			wrap={{
				[Breakpoints.default]: 'always',
				[Breakpoints.b1600]: 'never',
			}}
		>
			<Layout
				data-testid="hucha-card-layout"
				appearance={{
					[Breakpoints.default]: [
						{ name: 'popup-hucha-card-c2', columns: 24 },
						{ name: 'popup-hucha-card-c3', columns: 24 },
					],
					[Breakpoints.b1600]: [
						{ name: 'popup-hucha-card-c2', columns: 10 },
						{ name: 'popup-hucha-card-c3', columns: 14 },
					],
				}}
			>
				{children}
			</Layout>
		</PopupHuchaCardBackground>
	);
};

export const PopupHuchaCardContainer2: React.FC<{ children: React.ReactNode }> = ({ children }) => {
	return (
		<PopupHuchaCardBackground2
			stretchContent
			verticalAlign="center"
			horizontalAlign="center"
			data-testid="hucha-card-container"
			wrap={{
				[Breakpoints.default]: 'always',
				[Breakpoints.b1600]: 'never',
			}}
		>
			<Layout
				data-testid="hucha-card-layout"
				appearance={{
					[Breakpoints.default]: [
						{ name: 'popup-hucha-card-c2', columns: 24 },
						{ name: 'popup-hucha-card-c3', columns: 24 },
					],
					[Breakpoints.b960]: [
						{ name: 'popup-hucha-card-c2', columns: 12 },
						{ name: 'popup-hucha-card-c3', columns: 12 },
					],
				}}
			>
				{children}
			</Layout>
		</PopupHuchaCardBackground2>
	);
};
